import React from 'react';
import { useLanguage } from '@/contexts/LanguageContext';

/**
 * SkipLink — enlace "Saltar al contenido" oculto hasta recibir foco.
 * Mejora navegación por teclado (WCAG 2.4.1).
 * Coloca <SkipLink /> como primer elemento del <body>/AppLayout.
 */
export const SkipLink: React.FC<{ targetId?: string }> = ({ targetId = 'main-content' }) => {
  const { language } = useLanguage();
  const label = language === 'es' ? 'Saltar al contenido principal' : 'Skip to main content';

  return (
    <a
      href={`#${targetId}`}
      className={[
        'sr-only focus:not-sr-only',
        'fixed top-3 left-3 z-[100]',
        'px-4 py-2 rounded-lg',
        'bg-primary text-primary-foreground text-sm font-medium',
        'shadow-lg outline-none ring-2 ring-primary/40',
      ].join(' ')}
    >
      {label}
    </a>
  );
};

export default SkipLink;
